import React, { useEffect, useState } from 'react';
import { TextFieldLayoutItem, SelectLayoutItem, CheckboxLayoutItem } from 'models/InputLayoutItem';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import * as yup from 'yup';
import { regiones } from 'constants/Regiones';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE, YUP } from 'constants/FormConstants';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { comunas } from 'constants/Comunas';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso6 = () => {
	const address = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.ADDRESS,
		sessionStorage
	);
	const region = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.REGION,
		sessionStorage
	);
	const locality = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.LOCALITY,
		sessionStorage
	);

	const [resetField, setResetField] = useState('');
	const [fields, setfields] = useState<any[]>([
		{
			label: 'Dirección particular',
			defaultValue: address ? address : '',
			name: FORM.ADDRESS,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: Los Navios 123',
			validation: yup.string().required(YUP.FIELD_REQUIRED),
		} as TextFieldLayoutItem,
		{
			defaultValue: region ? region : '',
			label: 'Región',
			name: FORM.REGION,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: regiones,
			validation: yup.string().required(YUP.FIELD_REQUIRED),
		} as SelectLayoutItem,
		{
			defaultValue: locality ? locality : '',
			label: 'Comuna',
			name: FORM.LOCALITY,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [],
			validation: yup.string().required(YUP.FIELD_REQUIRED),
		} as SelectLayoutItem,
		{
			defaultValue: false,
			label: '',
			name: FORM.CONSENT_CHECKED,
			type: LAYOUT_ITEM.TYPE.CONSENT_CHECKBOX,
			validation: yup.boolean().required(YUP.CONSENT_ACCEPT).oneOf([true], YUP.CONSENT_ACCEPT),
		} as CheckboxLayoutItem,
	]);

	const addLocality = (regionValue: string) => {
		let newFields = fields;
		newFields[2].options = comunas.get(regionValue);
		setfields(newFields);
		setResetField('locality');
	};

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_6),
			});
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Para finalizar"
				body="Indícanos tu dirección particular. Usaremos esta información para terminar de completar tu solicitud "
			/>
			<CreateFormLayout
				key={fields.length}
				fields={fields}
				resetField={resetField}
				watchField={['region']}
				customEvent={(values) => {
					if (values.region !== '') {
						addLocality(values.region);
					}
				}}
			/>
		</div>
	);
};
